/**
 * Utility for generating random encryption keys
 */

/**
 * Generates a random base64-encoded encryption key suitable for AES-256
 * @returns A 32-byte key encoded as base64 string
 */
export function generateEncryptionKey(): string {
  // Generate 32 random bytes for AES-256
  const keyBytes = new Uint8Array(32)
  crypto.getRandomValues(keyBytes)
  
  // Convert to base64
  return btoa(String.fromCharCode(...keyBytes))
}

/**
 * Validates if a string is a valid base64 encryption key
 * @param key The key to validate
 * @returns true if valid, false otherwise
 */
export function isValidEncryptionKey(key: string): boolean {
  try {
    // Check if it's valid base64
    const decoded = atob(key)
    // Should be at least 32 bytes for AES-256
    return decoded.length >= 32
  } catch {
    return false
  }
}